import React, { useState } from 'react';
import { Box, Divider, Tab, Tabs, Typography, CircularProgress } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { Comments, DataLayout } from '../../../../shared/components';
import { useGetQueryDetails } from '../../../queries/mutation';
import { formatDate } from '../../../../shared/utils/formatDate';

interface ContractorQueryDrawerProps {
    queryId: number;
}

export const ContractorQueryDrawer: React.FC<ContractorQueryDrawerProps> = ({ queryId }) => {
    const [currentTab, setCurrentTab] = useState('overview');
    const { queryDetails, isFetching, isPending } = useGetQueryDetails({ queryId: String(queryId) });

    const handleChangeTab = (_e: React.SyntheticEvent, tab: string) => {
        setCurrentTab(tab);
    };

    if (isFetching || isPending) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" height="100%">
                <CircularProgress />
            </Box>
        );
    }

    if (!queryDetails) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" height="100%">
                <Typography>No query details</Typography>
            </Box>
        );
    }

    return (
        <Box height="100%" display="flex" flexDirection="column">
            <TabContext value={currentTab}>
                <Tabs
                    value={currentTab}
                    onChange={handleChangeTab}
                    aria-label="Tabs"
                    sx={{ minHeight: 'auto' }}
                >
                    <Tab sx={{ height: 'auto', minHeight: 'auto' }} label="Overview" value="overview" />
                    <Tab sx={{ height: 'auto', minHeight: 'auto' }} label="Comments" value="comments" />
                </Tabs>
                <Divider />
                <TabPanel value="overview" sx={{ p: 2, height: 'calc(100% - 50px)', overflowY: 'auto', flex: 1 }}>
                    <DataLayout title="Query Details">
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
                            {[
                                { label: 'Query ID', value: queryDetails?.id },
                                { label: 'Title', value: queryDetails?.title },
                                { label: 'Description', value: queryDetails?.description },
                                { label: 'Status', value: queryDetails?.status },
                                { label: 'Raised By', value: queryDetails?.raised_by },
                                { label: 'Assigned to', value: queryDetails?.assigned_to },
                                {
                                    label: 'Date Submitted',
                                    value: queryDetails?.submitted_date
                                        ? formatDate(queryDetails?.submitted_date)
                                        : '-',
                                },
                            ].map((item, index) => (
                                <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">
                                        {item.label}
                                    </Typography>
                                    <Typography variant="body2" color="text.primary">
                                        {item.value}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </DataLayout>
                </TabPanel>
                <TabPanel value="comments" sx={{ p: 2, height: 'calc(100% - 50px)', overflowY: 'auto', flex: 1 }}>
                    <Comments
                        topic={['QUERIES_COMMENT_ADDED']}
                        sub_event={['QUERIES_AND_RFIS']}
                        object_id={queryDetails?.id}
                        parent_id=""
                    />
                </TabPanel>
            </TabContext>
        </Box>
    );
};
